import React, { useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { HolidayRate } from "../../components/holidayRate";
import { HOLIDAY_DIFFERENTIAL, truncateToTwoDecimals } from "../../constants/facility";
import { Facility } from "@src/interface";

interface HolidayRateConfig {
  type: string;
  increment: number;
}

interface Props {
  visible: boolean;
  onCancel: (holidayRateConfig?: HolidayRateConfig) => void;
  holidayRateConfig?: HolidayRateConfig | [];
  onUpdateRateConfig: (data: { holidayFee: HolidayRateConfig }) => void;
  facility: Facility;
}

function HolidayRateModal({
  visible,
  onCancel,
  holidayRateConfig,
  onUpdateRateConfig,
  facility,
}: Props) {
  const [buttonDisable, setButtonDisable] = useState(true);
  const [newHolidayRateConfig, setNewHolidayRateConfig] = useState<HolidayRateConfig>({
    type: "",
    increment: 0,
  });
  const { FLAT, CHARGE_RATE_MULTIPLIER } = HOLIDAY_DIFFERENTIAL;

  const validHolidayRateConfig =
    Array.isArray(holidayRateConfig) || !holidayRateConfig ? undefined : holidayRateConfig;

  function generateNewHolidayRateConfig(option: string, value: number) {
    if (value >= 1) {
      setButtonDisable(false);
      const increment = option === CHARGE_RATE_MULTIPLIER ? truncateToTwoDecimals(value) : value;
      setNewHolidayRateConfig({
        type: option === FLAT ? FLAT : CHARGE_RATE_MULTIPLIER,
        increment,
      });
    } else {
      setButtonDisable(true);
    }
  }

  function handleHolidayRateOnChange(option: string, value: number) {
    if (
      validHolidayRateConfig &&
      (validHolidayRateConfig.type !== option || validHolidayRateConfig.increment !== value)
    ) {
      generateNewHolidayRateConfig(option, value);
    } else if (!validHolidayRateConfig) {
      generateNewHolidayRateConfig(option, value);
    } else {
      setButtonDisable(true);
    }
  }

  function onSave() {
    onUpdateRateConfig({
      ...facility,
      holidayFee: newHolidayRateConfig,
    });
  }

  function handleCancel() {
    onCancel();
  }

  return (
    <Dialog open={visible} onClose={handleCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box component="strong">Edit Holiday Fee</Box>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ paddingTop: 1 }}>
          <HolidayRate
            holidayRateConfig={validHolidayRateConfig}
            handleChange={handleHolidayRateOnChange}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button disabled={buttonDisable} variant="contained" onClick={onSave}>
          Submit Holiday fee
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export { HolidayRateModal };
